import {
  AddJobRequest,
  AddJobResponse,
  ChangeJobRequest,
  ChangeJobResponse,
  CorretJobRequest,
  CorretJobResponse,
  EditAIKeysRequest,
  EditAIKeysResponse,
  EditAITextRequest,
  EditAITextResponse,
  JOB_ADD_URL,
  JOB_CHANGE_AI_KEYWORDS_URL,
  JOB_CHANGE_AI_TEXT_URL,
  JOB_CHANGE_CORRECT_URL,
  JOB_CHANGE_URL,
  JOBS_PAID_URL,
  JobsPaidCountRequest,
  JobsPaidCountResponse,
  ORDER_PAY_JOBS,
  PayJobsRequest,
  PayJobsResponse,
} from "@project/shared-types";
import apiFetchPost from "../../../api/apiClient";

export const JobChangeAPI = async (dataRequest: ChangeJobRequest) => {
  try {
    const response = await apiFetchPost<ChangeJobRequest, ChangeJobResponse>(
      JOB_CHANGE_URL,
      dataRequest
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const JobChangeAITextAPI = async (dataRequest: EditAITextRequest) => {
  try {
    const response = await apiFetchPost<EditAITextRequest, EditAITextResponse>(
      JOB_CHANGE_AI_TEXT_URL,
      dataRequest
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const JobChangeAIKeysAPI = async (dataRequest: EditAIKeysRequest) => {
  try {
    const response = await apiFetchPost<EditAIKeysRequest, EditAIKeysResponse>(
      JOB_CHANGE_AI_KEYWORDS_URL,
      dataRequest
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const JobChangeCorrectAPI = async (dataRequest: CorretJobRequest) => {
  try {
    const response = await apiFetchPost<CorretJobRequest, CorretJobResponse>(
      JOB_CHANGE_CORRECT_URL,
      dataRequest
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const JobsPaidCountAPI = async (dataRequest: JobsPaidCountRequest) => {
  try {
    const response = await apiFetchPost<
      JobsPaidCountRequest,
      JobsPaidCountResponse
    >(JOBS_PAID_URL, dataRequest);
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
export const JobAddAPI = async (dataRequest: AddJobRequest) => {
  try {
    const response = await apiFetchPost<AddJobRequest, AddJobResponse>(
      JOB_ADD_URL,
      dataRequest
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
export const OrderPayJobsAPI = async (dataRequest: PayJobsRequest) => {
  try {
    const response = await apiFetchPost<PayJobsRequest, PayJobsResponse>(
      ORDER_PAY_JOBS,
      dataRequest
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
